import {
  subtype as s,
  subtypeCatalog as c,
  withSubtypeImages as withImages,
} from './catalog-builder';

export const APPAREL_PRODUCT_SUBTYPE_CATALOGS = [
  c(
    't-shirt',
    ['T-shirt', 'T-Shirt'],
    withImages('t-shirt', [
      s('crew-neck', 'Crew-neck', 'round crew neckline', 'closed collar line'),
      s('v-neck', 'V-neck', 'V-shaped neckline', 'open front neck point'),
      s(
        'scoop-neck',
        'Scoop-neck',
        'wide curved neckline',
        'lower front neck drop'
      ),
      s('henley', 'Henley', 'round neckline', 'short button placket'),
      s(
        'raglan',
        'Raglan',
        'sleeves extending to neckline',
        'diagonal arm seams'
      ),
      s(
        'ringer',
        'Ringer',
        'contrast-style neck binding',
        'bound sleeve openings'
      ),
      s(
        'pocket-t-shirt',
        'Pocket T-shirt',
        'crew-style body',
        'single chest pocket'
      ),
      s('long-sleeve', 'Long-sleeve', 'wrist-length sleeves', 'T-shirt body'),
      s(
        'baseball',
        'Baseball',
        'three-quarter raglan sleeves',
        'crew neckline'
      ),
      s('muscle', 'Muscle', 'sleeveless armholes', 'T-shirt body length'),
      s(
        'cap-sleeve',
        'Cap-sleeve',
        'short shoulder-covering sleeves',
        'fitted arm openings'
      ),
      s(
        'mock-neck',
        'Mock-neck',
        'short raised neckline',
        'closed collar line'
      ),
    ])
  ),
  c(
    'hoodie',
    ['Hoodie'],
    withImages('hoodie', [
      s('pullover', 'Pullover', 'fixed hood', 'unbroken front body'),
      s('full-zip', 'Full-zip', 'fixed hood', 'full-length front opening'),
      s('half-zip', 'Half-zip', 'fixed hood', 'partial front zip opening'),
      s('sleeveless', 'Sleeveless', 'fixed hood', 'open sleeveless armholes'),
      s(
        'anorak',
        'Anorak',
        'fixed hood',
        'partial front opening',
        'large front pocket'
      ),
      s(
        'funnel-neck',
        'Funnel-neck',
        'hood joined to high neck',
        'raised front collar'
      ),
      s(
        'cowl-neck',
        'Cowl-neck',
        'hood joined to draped neckline',
        'folding neck volume'
      ),
    ])
  ),
  c(
    'dress',
    ['Dress'],
    withImages('dress', [
      s('a-line', 'A-line', 'fitted upper body', 'skirt widening toward hem'),
      s('wrap', 'Wrap', 'overlapping front panels', 'side waist closure'),
      s('shirt', 'Shirt', 'shirt collar', 'buttoned front opening'),
      s('slip', 'Slip', 'narrow shoulder straps', 'straight fluid body'),
      s('sheath', 'Sheath', 'close body fit', 'straight narrow skirt'),
      s('shift', 'Shift', 'straight body shape', 'minimal waist shaping'),
      s(
        'fit-and-flare',
        'Fit-and-flare',
        'fitted bodice',
        'flared skirt from waist'
      ),
      s(
        'empire-waist',
        'Empire-waist',
        'raised waist seam',
        'skirt falling below bust'
      ),
      s('babydoll', 'Babydoll', 'raised short bodice', 'loose gathered skirt'),
      s(
        'column',
        'Column',
        'long straight silhouette',
        'narrow consistent width'
      ),
      s('mermaid', 'Mermaid', 'close fit through knee', 'dramatic lower flare'),
      s('peplum', 'Peplum', 'fitted waist', 'short overskirt at waist'),
      s('sweater', 'Sweater', 'knit dress construction', 'pullover neckline'),
      s('gown', 'Gown', 'floor-length skirt', 'formal fitted bodice'),
      s('caftan', 'Caftan', 'wide straight body', 'loose full-length sleeves'),
    ])
  ),
  c(
    'jean',
    ['Jean'],
    withImages('jean', [
      s(
        'straight-leg',
        'Straight-leg',
        'consistent leg width',
        'straight outer seam'
      ),
      s('skinny', 'Skinny', 'close fit through leg', 'narrow ankle opening'),
      s('slim', 'Slim', 'trim thigh fit', 'gently tapered lower leg'),
      s('relaxed', 'Relaxed', 'roomy seat and thigh', 'loose leg'),
      s('tapered', 'Tapered', 'roomy upper leg', 'narrowing ankle opening'),
      s('wide-leg', 'Wide-leg', 'wide leg from hip', 'broad hem opening'),
      s('bootcut', 'Bootcut', 'fitted thigh', 'subtle flare below knee'),
      s('flare', 'Flare', 'fitted upper leg', 'pronounced flare below knee'),
      s(
        'boyfriend',
        'Boyfriend',
        'relaxed rise and seat',
        'loose rolled-capable leg'
      ),
      s('mom', 'Mom', 'high rise', 'roomy hip', 'tapered ankle'),
      s('barrel-leg', 'Barrel-leg', 'curved outward leg', 'tapered hem'),
      s(
        'carpenter',
        'Carpenter',
        'straight utility fit',
        'side tool loop',
        'utility pockets'
      ),
    ])
  ),
  c(
    'scarf',
    ['Scarf'],
    withImages('scarf', [
      s('square', 'Square', 'equal-length sides', 'flat square panel'),
      s('oblong', 'Oblong', 'long rectangular panel', 'narrow width'),
      s(
        'infinity',
        'Infinity',
        'closed fabric loop',
        'continuous circular form'
      ),
      s('shawl', 'Shawl', 'broad wrap width', 'shoulder-covering length'),
      s('wrap', 'Wrap', 'long wide panel', 'body-wrapping proportions'),
      s(
        'pashmina',
        'Pashmina',
        'long rectangular panel',
        'generous draping width'
      ),
      s('cowl', 'Cowl', 'short closed neck loop', 'draped front folds'),
      s(
        'neckerchief',
        'Neckerchief',
        'small square panel',
        'neck-scale proportions'
      ),
      s('bandana', 'Bandana', 'small square panel', 'foldable triangular wear'),
      s(
        'blanket-scarf',
        'Blanket scarf',
        'oversized square panel',
        'broad wrap coverage'
      ),
      s('cravat', 'Cravat', 'narrow neck band', 'widened front tails'),
    ])
  ),
  c(
    'intimates',
    ['Intimates', 'Intimate apparel', 'Underwear', 'Lingerie'],
    withImages('intimates', [
      s(
        'underwire-bra',
        'Underwire bra',
        'two shaped breast cups',
        'under-cup wire channels',
        'adjustable shoulder straps'
      ),
      s('bralette', 'Bralette', 'soft wireless cups', 'lightweight underband'),
      s(
        'camisole',
        'Camisole',
        'hip-length sleeveless body',
        'narrow shoulder straps'
      ),
      s('slip', 'Slip', 'dress-length body', 'narrow shoulder straps'),
      s(
        'bodysuit',
        'Bodysuit',
        'one-piece torso body',
        'brief-style lower section'
      ),
      s(
        'classic-brief',
        'Classic brief',
        'full front and back coverage',
        'waist-level rise'
      ),
      s(
        'bikini-brief',
        'Bikini brief',
        'low-rise waistband',
        'high-cut leg openings'
      ),
      s(
        'hipster',
        'Hipster',
        'low hip-level waistband',
        'straight low-cut leg openings'
      ),
      s('thong', 'Thong', 'full front panel', 'narrow rear coverage'),
      s(
        'boyshort',
        'Boyshort',
        'low horizontal leg openings',
        'short full-coverage body'
      ),
      s(
        'boxer-brief',
        'Boxer brief',
        'fitted trunk body',
        'short close-fitting legs'
      ),
      s(
        'shapewear-short',
        'Shapewear short',
        'high-rise compression body',
        'mid-thigh fitted legs'
      ),
    ])
  ),
] as const;
